import type { PageResult, UserKey } from '@smartsash/types';

// DTO → view-model adapters (03-03 §2.4). Where the raw generated DTO is awkward
// for screens, normalize it here — never inside the generated tree.

/**
 * Structural shape of every generated `*PaginationResult` envelope (all share
 * these fields). Kept structural so one adapter serves all entities without
 * importing 12 near-identical generated types.
 */
export interface PaginationResultLike<T> {
  items?: T[] | null;
  page?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
}

/** Backend `PaginationResult*` → the `PageResult<T>` data-screen consumes. */
export function toPageResult<T>(result: PaginationResultLike<T> | undefined): PageResult<T> {
  const items = result?.items ?? [];
  return {
    items,
    total: result?.totalCount ?? items.length,
    page: result?.page ?? 1,
    pageSize: result?.pageSize ?? items.length,
  };
}

/**
 * Path-param mapper for the composite user key. Q-10 (HS-939) landed: users now
 * route as `/api/User/{institutionId}/{userId}`, so the key maps straight onto the
 * generated path slots. Kept as an adapter so call sites don't destructure `UserKey`.
 */
export function userKeyToPathParams(key: UserKey): { institutionId: string; userId: string } {
  return { institutionId: key.institutionId, userId: key.userId };
}
